import { render, staticRenderFns } from "./ApplicationDetail.vue?vue&type=template&id=2550e246&"
import script from "./applicationDetail.js?vue&type=script&lang=js&"
export * from "./applicationDetail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports